import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/manga";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "人气榜", path: "/category/hot" },
  { name: "完结榜", path: "/category/completed" },
  { name: "新作", path: "/category/new" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  const navCls = scrolled
    ? "bg-background-50/95 backdrop-blur border-b border-background-200/80 shadow-sm"
    : "bg-transparent";

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navCls}`}>
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-2xl md:text-3xl text-primary-600">91漫画</span>
        </Link>

        {/* desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.slice(0, 1).map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-100 ${
                location.pathname === l.path ? "text-primary-600" : "text-foreground-700"
              }`}
            >
              {l.name}
            </Link>
          ))}

          {/* categories dropdown */}
          <div className="relative" onMouseEnter={() => setCatOpen(true)} onMouseLeave={() => setCatOpen(false)}>
            <button
              type="button"
              className="flex items-center gap-1 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap text-foreground-700 hover:bg-primary-100 cursor-pointer"
              onClick={() => setCatOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={catOpen}
            >
              漫画分类
              <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? "rotate-180" : ""}`}></i>
            </button>
            {catOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 rounded-xl bg-background-50 border border-background-200 p-2 shadow-lg">
                <div className="grid grid-cols-2 gap-1">
                  {categories.map((c) => (
                    <Link
                      key={c.slug}
                      to={`/category/${c.slug}`}
                      className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-600 whitespace-nowrap"
                    >
                      <i className={`${c.icon} text-primary-500`}></i>
                      {c.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navLinks.slice(1).map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-100 ${
                location.pathname === l.path ? "text-primary-600" : "text-foreground-700"
              }`}
            >
              {l.name}
            </Link>
          ))}

          <Link
            to="/category/rexue"
            className="ml-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600"
          >
            开始阅读
          </Link>
        </nav>

        {/* mobile hamburger */}
        <button
          type="button"
          className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-800 hover:bg-background-100 cursor-pointer"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="打开菜单"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {/* mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium ${
                  location.pathname === l.path ? "text-primary-600 bg-primary-100" : "text-foreground-700"
                }`}
              >
                {l.name}
              </Link>
            ))}
            <div className="grid grid-cols-3 gap-1 mt-2 pt-2 border-t border-background-200">
              {categories.map((c) => (
                <Link
                  key={c.slug}
                  to={`/category/${c.slug}`}
                  className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs text-foreground-700 hover:bg-primary-100"
                >
                  <i className={`${c.icon} text-primary-500`}></i>
                  {c.name}
                </Link>
              ))}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}